import * as React from 'react';
import parse from 'html-react-parser';
import { IconComponentProps } from './types';
import * as iconsMaterialIU from '@mui/icons-material';
import MaterialIcon from '@mui/material/Icon';

export const InnoboIcon = ({ name, ...props }: IconComponentProps) => {
  //const myParse = parse(myIcons[name]);
  const {
    color = 'currentColor',
    size = 24,
    strokeWidth = 2,
    onClick,
    ...otherProps
  } = props;

  return (
    <>
      {name.toString().slice(0, 2) == "bx" || name.toString().slice(0, 2) == "dr" || name.toString().includes(" ") ? (<i className={name.toString()}></i>) : (

          <MaterialIcon
            component={iconsMaterialIU[name.toString() as keyof typeof iconsMaterialIU]}
          />
      )}

    </>
  )





};

export default InnoboIcon;
